import PropTypes from 'prop-types';
import classnames from 'classnames';
import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  Button,
  useId,
} from '@fluentui/react-components';
import {
  Dismiss12Regular,
} from '@fluentui/react-icons';
import { useCampaignNameTagStyles } from '../../styles';

export const CampaignNameTag = ({
  campaign,
  onRemove,
}) => {
  const i18n = useContext(I18nContext);
  const tagsListId = useId('selectedCampaignsTagsList');
  const removeTagId = `${tagsListId}-remove-${campaign.Id}`;
  const campaignName = i18n.getString(_TL_('{{name}}'), { name: campaign.Name });
  const styles = useCampaignNameTagStyles();

  return (
    <Button
      appearance="outline"
      aria-labelledby={removeTagId}
      className={classnames('experiment-summary-campaign', styles.button)}
      icon={<Dismiss12Regular />}
      iconPosition="after"
      id={campaign.Id}
      onClick={() => onRemove(campaign.Id)}
      shape="rounded"
      size="small"
    >
      {campaignName}
    </Button>
  );
};

CampaignNameTag.propTypes = {
  campaign: PropTypes.shape({
    Id: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
};
